module.exports = __webpack_public_path__ + "img/mtg-img.30626fe7.jpeg";